<template>
	<v-dialog
		ref="dialog"
		v-model="modal"
		:return-value.sync="date"
		persistent
		lazy
		full-width
		width="290px"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				class="ml-2"
				v-model="date"
				label="Kündigungsdatum"
				append-icon="event"
				readonly
				v-on="on"
			></v-text-field>
		</template>
		<v-date-picker
			v-model="date"
			first-day-of-week="1"
			locale="de-DE"
			no-title
			:value="initialDate"
		>
			<v-spacer></v-spacer>
			<v-btn flat color="primary" @click="modal = false">Abbrechen</v-btn>
			<v-btn flat color="primary" @click="save()">OK</v-btn>
		</v-date-picker>
	</v-dialog>
</template>

<script>
import * as moment from 'moment';
import { mapState } from 'vuex';

export default {
	computed: {
		...mapState({
			initialDate: state => state.notice,
		}),
	},
	methods: {
		save() {
			this.$refs.dialog.save(this.date);
			const inputDate = moment(this.date);
			const noticegt3weeks = moment().diff(inputDate, 'days') > 21;

			this.$store.dispatch('setNotice', {
				date: this.date,
				noticegt3weeks,
			});
			this.$emit('save', noticegt3weeks);
		},
	},
	created() {
		this.date = this.initialDate;
	},
	data: () => {
		return {
			date: null,
			modal: false,
		};
	},
};
</script>
